export enum AuthenticationType {
  OKTA = 'okta',
  IDENTITY = 'identity',
  AUTH0 = 'auth0',
  NONE = 'none',
}
